var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "col-12 p-0" }, [
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "col-12 card-container mt-4 p-3",
              class: _vm.statusClass
            },
            [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _vm.status
                  ? _c(
                      "div",
                      {
                        staticClass: "border-right pt-2",
                        class: [
                          _vm.getStatusClasses,
                          {
                            "d-flex flex-column justify-content-between":
                              _vm.$slots["extra"],
                            "align-items-center d-flex":
                              !_vm.$slots["statusInfo"] && !_vm.$slots["extra"]
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _c(
                            "p",
                            {
                              staticClass: "text-center py-2 px-4 status-pill",
                              class: [
                                _vm.statusClass,
                                { "mb-0": _vm.$slots["extra"] }
                              ]
                            },
                            [_vm._v(" " + _vm._s(_vm.status) + " ")]
                          )
                        ]),
                        _vm._t("statusInfo"),
                        _vm.$slots["extra"]
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "dot text-center cursor-pointer",
                                  class: _vm.getBgIcon(_vm.extraExpanded),
                                  on: {
                                    click: function($event) {
                                      _vm.extraExpanded = !_vm.extraExpanded
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "title-icon",
                                    class: _vm.getIcon(_vm.extraExpanded)
                                  })
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm.$slots["dynamicExtra"]
                          ? _c("div", [_vm._m(0)])
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    class: {
                      "col-8": _vm.$slots["actions"],
                      "col-10": !_vm.$slots["actions"] || !_vm.status,
                      "col-12": !_vm.status && !_vm.$slots["actions"]
                    }
                  },
                  [_vm._t("body")],
                  2
                ),
                _vm.$slots["actions"]
                  ? _c(
                      "div",
                      { staticClass: "col-2 pt-2" },
                      [_vm._t("actions")],
                      2
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm.extraExpanded ? _vm._t("extra") : _vm._e(),
          _vm._t("dynamicExtra")
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "green dot text-center cursor-pointer" }, [
      _c("i", { staticClass: "fas fa-chevron-down title-icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }